import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage } from "react-intl";

interface DialogErrorProps {
  onClose: () => void;
  open: boolean;
  onOk: () => void;
  title?: React.ReactNode | string;
  content?: React.ReactNode | string;
  loading?: boolean;
  okText?: string;
  cancelText?: string;
  testId?: string;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 420,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    btnAction: {
      height: 48
    },
    btnActionSecondary: {
      height: 48,
      "&.Mui-disabled": {
        "& .MuiTypography-root": {
          color: "lightgray"
        }
      }
    }
  }),
  { name: "DialogConfirmOrder" }
);

const DialogConfirmOrder: React.FC<DialogErrorProps> = ({
  onClose,
  open,
  onOk,
  title,
  content,
  loading = false,
  cancelText,
  okText,
  testId
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      data-testid={testId ?? "dialogConfirmChangeOrder"}
    >
      <DialogTitle>
        <MyTypography variant="h6">{title}</MyTypography>
      </DialogTitle>
      <DialogContent>
        <MyTypography variant="body2">{content}</MyTypography>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          id="cancelButton"
          data-testid="cancelButton"
          color="secondary"
          variant="outlined"
          className={classes.btnActionSecondary}
          fullWidth={true}
          onClick={onClose}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {cancelText ? (
              cancelText
            ) : (
              <FormattedMessage defaultMessage="ยกเลิก" />
            )}
          </MyTypography>
        </Button>
        <Button
          id="confirmButton"
          data-testid="confirmButton"
          color="secondary"
          variant="contained"
          className={classes.btnAction}
          fullWidth={true}
          onClick={onOk}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {okText ? okText : <FormattedMessage defaultMessage="ยืนยัน" />}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmOrder;
